import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import _get from 'lodash/get';
import { selectGeoDistribution } from 'selectors/pastMeetingParticipantsSelector';
import PastMeetingDetails from 'components/PastMeetingDetails/PastMeetingDetails';
import PastConferenceDetailsQuery from 'queries/pastMeetings/PastConferenceDetailsQuery.gql';
import { featureSelectors } from '@lifesize/nucleus';
import { FEATURE_FLAG_GEO_DISTRIBUTION } from 'constants/featureFlags';
import { Global } from 'state/Global';

interface ComponentProps {
  match: {
    params: {
      id: string
    };
  };
}

const mapStateToProps = (state: Global) => ({
  geoDistributionFeature: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_GEO_DISTRIBUTION)
});

const mapDispatchToProps = () => ({});

export default withRouter(compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  graphql(PastConferenceDetailsQuery, {
    options: (props: ComponentProps) => {
      return {
        fetchPolicy: 'network-only',
        variables : { conferenceId: props.match.params.id }
      };
    },
    // tslint:disable-next-line
    props: ({ data, ownProps }: any) => {
      const pastConferenceDetails = _get(data, 'pastConferenceDetails');
      const geoDistribution = selectGeoDistribution(data);

      return {
        ...ownProps,
        moderators: _get(pastConferenceDetails, 'moderators', []),
        recordings: _get(pastConferenceDetails, 'recording', []),
        data,
        loading: data.loading,
        pastConferenceDetails,
        meetingName: _get(pastConferenceDetails, 'meetingName'),
        extension: _get(pastConferenceDetails, 'extension'),
        conferenceType: _get(pastConferenceDetails, 'conferenceType'),
        quality: _get(pastConferenceDetails, 'quality'),
        startedAt: _get(pastConferenceDetails, 'startedAt'),
        totalParticipants: _get(pastConferenceDetails, 'totalParticipants'),
        endedAt: _get(pastConferenceDetails, 'endedAt'),
        duration: _get(pastConferenceDetails, 'duration'),
        participants: _get(pastConferenceDetails, 'participants'),
        conferenceId: _get(ownProps, 'match.params.id'),
        geoDistribution,
        showGeoDistribution: geoDistribution.length && ownProps.geoDistributionFeature,
      };
    },
  }),
)(PastMeetingDetails));
